import type { Product } from "@decocms/apps-commerce/types";
import { useEffect, useState } from "react";
import { formatPrice } from "@decocms/apps-commerce/sdk/formatPrice";
import { useOffer } from "~/sdk/useOffer";

export interface Props {
  product: Product;
  cashBackFlagPercentage?: number;
  cashBackCluster?: number | string;
  validateCluster?: boolean;
}

const CashBackFlag = (
  { product, cashBackFlagPercentage, cashBackCluster, validateCluster }: Props,
) => {
  const [discountWhithCashBack, setDiscountWhithCashBack] = useState<
    number | null
  >(null);
  const [validatedClustesForCashBack, setValidatedClustesForCashBack] =
    useState(false);

  const {
    offers,
  } = product;

  const {
    price = 0,
  } = useOffer(offers);

  useEffect(() => {
    if (typeof product !== "undefined" && cashBackFlagPercentage) {
      const calculatedDiscount = price * cashBackFlagPercentage / 100;
      setDiscountWhithCashBack(calculatedDiscount);
    }
  }, [product, cashBackFlagPercentage]);

  useEffect(() => {
    if (!validateCluster) {
      setValidatedClustesForCashBack(true);
      return;
    }

    if (typeof product !== "undefined" && cashBackCluster) {
      const mapClusters = product.additionalProperty?.find((item) =>
        String(item.propertyID) === String(cashBackCluster)
      );

      if (mapClusters) {
        setValidatedClustesForCashBack(true);
      }
    }
  }, [cashBackCluster, validateCluster, product]);

  if (!validatedClustesForCashBack) return <></>;

  return (
    <div className="flex items-center justify-center rounded-1 py-1 font-['Poppins','Times_New_Roman',Times,serif]
      font-normal text-[13px] leading-[16px] bg-[#fff] text-[#a67c52] gap-0.5">
      {discountWhithCashBack !== null && validatedClustesForCashBack
        ? (
          <>
            Ganhe {""}{" "}
            <strong>
              {formatPrice(discountWhithCashBack, offers?.priceCurrency)}
            </strong>
            {""} em Cashback
          </>
        )
        : (
          ""
        )}
    </div>
  );
};

export default CashBackFlag;
